<template lang="pug">
	span.matrixSelections(v-if="selected") {{ selected }}
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MatrixSelections",
  props: ["id"],
  computed: {
    ...mapGetters(["filters"]),
    selected() {
      if (this.filters[this.id]) {
        let keys = Object.keys(this.filters[this.id]);

        if (keys.length > 3) return `${keys.length} filters selected`;
        return keys.join(", ");
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.matrixSelections {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  color: $black;
	border-left: 5px solid $empire;
  width: 100%;
  margin: 0.5rem 0;
  padding: 5px;
  @media (min-width: 1100px) {
    background: $nevada;
		color: $white;
		border-left: none;
    width: auto;
    margin-top: 0;
    position: absolute;
    top: 100%;
    left: -1px;
    right: -1px;
		margin: 0;
		box-shadow: 0 0 10px rgba(0,0,0,0.1), 0 0 30px rgba(0,0,0,0.05);
  }
}
</style>